<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 16:53:31
 * @LastEditTime: 2024-07-10 14:03:11
 * @LastEditors: 张天昊
 * @Description: 变更信息面板
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/ModifyHistoryPanel.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import Description from './Description.vue';
import FileCell from './FileCell.vue';
import DataEmpty from './DataEmpty.vue';
import { usePanelMinHeight } from '../composables/usePanelMinHeight';
// import { dateStrFormat1 } from '../constants';
import { useFilePreview } from '../composables/useFilePreview';
import { FilePreviewer } from '@/components/FilePreviewer';
import store from '@/store';

export default defineComponent({
  components: {
    Description,
    FilePreviewer,
    FileCell,
    DataEmpty
  },
  setup() {
    const { panelMinHeight } = usePanelMinHeight();
    const { filePreviewerInst, onPreview } = useFilePreview();

    const describeMessages = computed(
      () => store.state.itineraryUniversal.detailInfo.value?.describeMessages
    );

    return {
      describeMessages,
      panelMinHeight,
      filePreviewerInst,
      onPreview
    };
  }
});
</script>

<template>
  <div class="px-12 pt-20" :style="{ minHeight: panelMinHeight }">
    <DataEmpty v-if="!describeMessages || describeMessages.length === 0" />
    <template v-else>
      <div class="text-16 leading-22 font-semibold">
        共{{ describeMessages.length }}条
      </div>
      <div
        v-for="(item, index) in describeMessages"
        :key="item.changeDate"
        class="p-12 rounded-4 bg-white mt-12"
      >
        <div class="text-green-primary flex justify-between text-14 leading-20">
          <span class="font-semibold"
            >第{{ describeMessages.length - index }}次变更记录</span
          >
          <span>{{ item.changeDate }}</span>
        </div>
        <Description
          :flex="false"
          class="mt-12"
          theme="dark"
          label="其他变更说明"
          :content="item.remark"
        />
        <Description
          :flex="false"
          class="mt-4"
          theme="dark"
          label="变更人"
          :content="item.creatorName"
        />
        <template>
          <van-divider class="custom-divider" />
          <div class="text-14 leading-22">附件</div>
          <FileCell
            v-for="(url, index) in item.filePath
              .split(',')
              .filter((url) => !!url)"
            :class="[index > 0 ? 'mt-10' : 'mt-4']"
            :key="url"
            :url="url"
            @click="onPreview"
          />
        </template>
      </div>
    </template>
    <FilePreviewer ref="filePreviewerInst" />
  </div>
</template>

<style scoped>
.custom-divider {
  margin: 12px 0;
}
</style>
